(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("elevator", [], factory);
	else if(typeof exports === 'object')
		exports["elevator"] = factory();
	else
		root["elevator"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 